import { checkSessionTokenRemainingTime } from "@/utils/sessionsDateTime";
import axiosWithInstance from "@/axios/index";
import axios from "axios";
import router from "@/router/index";
import Vue from "vue";

const API_URL = process.env.VUE_APP_URL;

export async function makeRequest(method, route, data, params, type) {
  const checkStatus = checkSessionTokenRemainingTime();

  if (checkStatus) {
    try {
      let config = {
        method: method,
        url: route,
        data: data,
        params: params,
      };

      if (type) {
        config = {
          ...config,
          responseType: type,
        };
      }

      const response = await axiosWithInstance(config);

      return {
        status: true,
        response: response.data,
      };
    } catch (error) {
      return { status: false, response: error };
    }
  } else {
    router.push({ path: "/" });
    localStorage.clear();
    Vue.prototype.$snackbar.setParams(
      "warning",
      "Usuário desconectado",
      "Realize o login novamente para ter acesso ao sistema."
    );
  }
}

export async function noAuthRequest(method, route, data, params) {
  try {
    const response = await axios({
      method: method,
      url: `${API_URL}/${route}`,
      data: data,
      params: params,
    });

    return {
      status: true,
      response: response.data,
    };
  } catch (error) {
    return { status: false, response: error };
  }
}

export async function anotherDomain(method, route, data, params) {
  try {
    const response = await axios({
      method: method,
      url: route,
      data: data,
      params: params,
    });

    return {
      status: true,
      response: response.data,
    };
  } catch (error) {
    return { status: false, response: error };
  }
}
